import { Adjustment } from '../../store/Adjustment';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const listAdjustments = async (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'runDate', direction: 'desc' }]
  };

  return await apiService.callExternalApi<PaginatedResponse<Adjustment>>({
    url: buildAdvancedQueryURL(mergedFilters, 'adjustment-tags'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const downloadAdjustmentsExcel = async (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'runDate', direction: 'desc' }]
  };

  return await apiService.callExternalApi<Blob>({
    url: buildAdvancedQueryURL(mergedFilters, 'adjustment-tags/export'),
    method: 'GET',
    responseType: 'blob'
  });
};

export const createAdjustment = (adjustmentData: Partial<Adjustment>) => {
  return apiService.callExternalApi<Adjustment>({
    url: `${API_SERVER_URL}/adjustment-tags`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: adjustmentData
  });
};

export const updateAdjustment = (adjustmentData: Partial<Adjustment>) => {
  return apiService.callExternalApi<Adjustment>({
    url: `${API_SERVER_URL}/adjustment-tags/${adjustmentData.adjustmentTagId}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: adjustmentData
  });
};

export const deleteAdjustment = (adjustmentTagId: string) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/adjustment-tags/${adjustmentTagId}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
